import { gql } from '@apollo/client';

export const GET_SCHEMAS_LIST = gql`
  query Schemas($params: FindSchemaListInput!) {
    schemas(params: $params) {
      success
      message
      errors
      data {
        schemas {
          id
          schemaName
          description
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_SCHEMA = gql`
  query Schema($params: FindSchemaInput!) {
    schema(params: $params) {
      success
      message
      errors
      data {
        id
        schemaName
        description
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
